import React from "react";
import CptShimmerBlock from "../CptShimmerBlock";

const MpcTabButtonShimmer = () => (
  <div className="mpc-tab mpr-shimmer-tab-shell">
    <CptShimmerBlock className="mpr-shimmer-tab-icon" />
    <div className="mpc-tab-text">
      <CptShimmerBlock className="mpr-shimmer-tab-label" />
      <CptShimmerBlock className="mpr-shimmer-tab-sublabel" />
    </div>
    <CptShimmerBlock className="mpr-shimmer-tab-count" />
  </div>
);

export default MpcTabButtonShimmer;
